import { useAdParameters } from './useAdParameters';
import { useDynamicCSS } from './useDynamicCSS';

export const DefaultRTLClassName = 'CreativeRTL';

export function useRTL<TConfig>(isRTL: (c: TConfig) => boolean): string {
  useDynamicCSS(`.${DefaultRTLClassName} {direction: rtl;}`);
  const { config } = useAdParameters<TConfig>();

  const rtl = isRTL(config);

  return rtl ? DefaultRTLClassName : '';
}
